export const isFirefox = () =>
  navigator.userAgent.toLowerCase().includes('firefox');

export const isOpera = () =>
  navigator.userAgent.toLowerCase().includes('opera');
